export function createAuthApi(baseUrl) {
  return {
    auth: {
      sendEmailOTP: `${baseUrl}/v1/auth/email/otp/`,
      loginWithEmail: `${baseUrl}/v1/auth/email/`,
      loginWithGoogle: `${baseUrl}/v1/auth/google/`,
      loginWithApple: `${baseUrl}/v1/auth/apple/`,
      logout: `${baseUrl}/v1/auth/logout/`,
    },
  };
}
